import { RadioGroup as FluentRadioGroup } from "@fluentui/web-components";
/**
 * RadioGroup
 * @summary A custom Radio Group element based on Fluent UI's RadioGroup with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-radio-group name="group1" orientation="horizontal">
 *   <fabric-radio value="option1">Option 1</fabric-radio>
 *   <fabric-radio value="option2">Option 2</fabric-radio>
 *   <fabric-radio value="option3">Option 3</fabric-radio>
 * </fabric-radio-group>
 * ```
 *
 * @attr {boolean} disabled - Disables the radio group and child radios.
 * @attr {string} value - The value of the checked radio.
 * @attr {string} name - The name of the radio group.
 * @attr {RadioGroupOrientation} orientation - The orientation of the group.
 * @attr {boolean} required - Indicates whether the radio group is required.
 *
 * @prop {boolean} disabled - Disables the radio group and child radios.
 * @prop {string} value - The value of the checked radio.
 * @prop {string} name - The name of the radio group.
 * @prop {RadioGroupOrientation} orientation - The orientation of the group.
 * @prop {boolean} required - Indicates whether the radio group is required.
 *
 * @slot - The default slot for the radio group.
 *
 * @method initialValueChanged - Sets the matching radio to checked when the value changes.
 * @method radiosChanged - Updates the enabled radios collection when properties on the child radios change.
 * @method requiredChanged - Called when the required property changes.
 * @method changeHandler - Sets the checked state of all radios when any radio emits a `change` event.
 * @method checkValidity - Checks the validity of the element and returns the result.
 * @method formResetCallback - Resets the radio group to its initial state during a form reset.
 * @method reportValidity - Reports the validity of the element.
 *
 * @fires change - Emits when the checked radio changes.
 *
 * @extends FASTElement
 * @tagname fabric-radio-group
 * @public
 */
export class RadioGroup extends FluentRadioGroup {
}
//# sourceMappingURL=radio-group.js.map